interface FormatOptions {
  locale?: string;
  decimals?: number;
  useGrouping?: boolean;
  currency?: string | null;
}

export function roundToDecimals(num: number, decimalPlaces: number) {
  return Number(num.toFixed(decimalPlaces));
}

export function formatCurrencyOrNumber(
  value: number | string,
  options: FormatOptions = {},
): string {
  const { locale = 'en-US', decimals = 2, useGrouping = true, currency = null } = options;

  if (isNaN(Number(value))) {
    return 'Invalid number';
  }

  const formatOptions: Intl.NumberFormatOptions = {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
    useGrouping: useGrouping,
  };

  if (currency) {
    formatOptions.style = 'currency';
    formatOptions.currency = currency;
  }

  return Number(value).toLocaleString(locale, formatOptions);
}
